// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { CLIENT_DETAILS_PID } from '../../config/API_Collection';
import { CLIENT_DETAILS_FAILURE, CLIENT_DETAILS_REQUEST, CLIENT_DETAILS_SUCCESS } from '../Actions/Actions';



function* fetchClientDetailsSaga({payload}) {
  try {
    const response = yield call(Axios.get,`${CLIENT_DETAILS_PID}${payload}`);
  
    
    const clientDetails = response.data.data || [];
    yield put({type:CLIENT_DETAILS_SUCCESS,payload:clientDetails});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:CLIENT_DETAILS_FAILURE,payload:error?.message});
  }
}

export default function* clientDetailsSagas() {
  yield takeLatest(CLIENT_DETAILS_REQUEST, fetchClientDetailsSaga);
}
